var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"font-size":"12px","color":"red"}},[_vm._v("\n  "+_vm._s(_vm.$t("admin.NoPartcipantToSearch"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }